
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {Scenario} from "@/scenarios/Scenarios";
    import {AwsService} from "@/simulation/AwsService";

    @Component({})
    export default class Simulator extends Vue {
        @Prop() private scenario!: Scenario;
        @Prop() private displayInput!: boolean;
        connectors: Array<object> = [];

        mounted() {
            // Wait for all child components to have also been mounted
            // See https://vuejs.org/v2/api/#mounted
            this.$nextTick(() => {
                this.updateConnectors();
            });
        }

        @Watch('scenario')
        onScenarioChange() {
            // Wait for all child components to have also been mounted
            // See https://vuejs.org/v2/api/#mounted
            this.$nextTick(() => {
                this.updateConnectors();
            });
        }

        private updateConnectors(): void {
            this.connectors = [];

            // Connection from the input
            if (this.displayInput) {
                this.scenario.getInputServices().forEach((serviceTo: AwsService) => {
                    const componentFrom = this.getComponentByRef('input');
                    this.connectors.push({
                        id: 'input-' + serviceTo.id,
                        from: componentFrom,
                        to: this.getComponentByRef('service' + serviceTo.id),
                    });
                });
            }

            // Connection between services
            const allServices = this.scenario.getAllServices();
            allServices.forEach((serviceFrom: AwsService) => {
                const componentFrom = this.getComponentByRef('service' + serviceFrom.id);
                serviceFrom.outputs().forEach((serviceTo: AwsService) => {
                    this.connectors.push({
                        id: serviceFrom.id + '-' + serviceTo.id,
                        from: componentFrom,
                        to: this.getComponentByRef('service' + serviceTo.id),
                    });
                });
            });
        }

        private getComponentByRef(ref: string): Vue | null {
            let component = this.$refs[ref];
            if (!component) {
                return null;
            }
            if (component instanceof Array) {
                // $refs can return an array
                // See https://forum.vuejs.org/t/this-refs-theid-returns-an-array/31995/2
                component = component[0];
            }
            if (component instanceof Element) {
                return null;
            }
            return component;
        }
    }
